import { render, staticRenderFns } from "./DialogUpdateSalesPerson.vue?vue&type=template&id=76668966&"
import script from "./DialogUpdateSalesPerson.vue?vue&type=script&lang=js&"
export * from "./DialogUpdateSalesPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports